import React, { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';
import { useSkyContext } from '../../store/provider';

const SnackbarUi: React.FC = () => {
  const [open, setOpen] = useState(false);
  const skyContext: any = useSkyContext();

  const handleClick = () => {
    setOpen(true);
  };

  useEffect(() => {
    setOpen(skyContext?.snackbar?.onOpen);
  }, [skyContext?.snackbar?.onOpen]);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };
  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={handleClose}
        severity={skyContext?.snackbar?.severity}
        sx={{ width: '100%' }}
      >
        {skyContext?.snackbar?.msg}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarUi;
